import SidebarMenuItem from 'components/SidebarMenuItem';
import SidebarBadge from 'components/SidebarBadge';
import styled from 'styled-components';
import { integrationsHash } from '@constants';
import useGeneralIntegrationPageContext from 'hooks/useGeneralIntegrationPageContext';
import { useIntegrationCountsQuery } from 'IntegrationModule/api/queries/useIntegrationCountsQuery';

const CounterBadge = styled(SidebarBadge)`
  flex-shrink: 0;
  margin-left: ${(props) => props.theme.spacing(1)};
`;

const IntegrationSidebar = ({ integrationId }: { integrationId: string }) => {
  const { intervalToUse, selectedIntegration } = useGeneralIntegrationPageContext();
  const { counts } = useIntegrationCountsQuery();

  // Fall back to the raw integrationId so the sidebar item remains
  // identifiable if `integrationsHash` drifts out of sync with the set of
  // services Galaxy renders for (e.g. a new agent comes online before the FE
  // constants are updated).
  const integrationLabel = integrationsHash[integrationId]?.label || integrationId;
  const integrationActiveCount = counts[integrationId];

  const integrationPath = `/integration/overall?targetService=${integrationId}&interval=${intervalToUse.id}`;

  return (
    <SidebarMenuItem
      name={integrationLabel}
      path={integrationPath}
      active={integrationId === selectedIntegration?.id}
      rightAdornment={
        integrationActiveCount !== undefined ? (
          <CounterBadge>{integrationActiveCount}</CounterBadge>
        ) : null
      }
    />
  );
};

export default IntegrationSidebar;
